export default "__VITE_ASSET__Dvk8eMRa__"